<div style="height: 98vh">
    <app-header></app-header>
    <div class="tile is-parent main-parent">
        <div class="tile is-child contents" style="width:fill-available">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
